import ApiClient from './ApiClient';

/**
 * 手当マスタ CRUD
 * 手本: src/api/executive.ts
 * ※ 手当申請（画面）用の API は src/api/attendAllowanceApplication.ts に置く
 */

export const getAllowanceList = async (): Promise<any> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const response = await ApiClient.get(`/v1/attendAllowance/list/${companyCode}`, {});
  return response.data;
};

export const getAllowanceById = async (allowanceId: string): Promise<any> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const response = await ApiClient.get(`/v1/attendAllowance/${companyCode}`, { allowanceId });
  return response.data;
};

export const createOrUpdateAllowance = async (data: any): Promise<any> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';

  // ★ GET のレスポンスをそのまま送り返さないこと。
  //    createDate / updateDate（ISO文字列）が混ざると、form-urlencoded では
  //    java.util.Date への型変換に失敗して 400 になる（新規は値が無いので通り、更新だけ落ちる）。
  //    送るのは画面で編集できる項目と主キーだけ。createUser / updateUser はサーバが設定する。
  const params = {
    allowanceId: data.allowanceId,
    allowanceCode: (data.allowanceCode || '').trim(),
    allowanceName: (data.allowanceName || '').trim(),
    dispMessage: (data.dispMessage || '').trim(),
    dispUnit: (data.dispUnit || '').trim(),
    deleted: data.deleted === true,
  };

  const response = await ApiClient.post(
    `/v1/attendAllowance/${companyCode}`,
    { loginStaffCode },
    params,
  );
  return response.data;
};

export const deleteAllowance = async (allowanceId: string): Promise<any> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  const response = await ApiClient.delete(
    `/v1/attendAllowance/${companyCode}`,
    { allowanceId, loginStaffCode },
  );
  return response.data;
};

export default {
  getAllowanceList,
  getAllowanceById,
  createOrUpdateAllowance,
  deleteAllowance,
};
